import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import classnames from 'classnames';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight';
import faCaretSquareRight from '@fortawesome/fontawesome-free-solid/faCaretSquareRight';
import faCaretSquareDown from '@fortawesome/fontawesome-free-solid/faCaretSquareDown';
import { getItemById, isTargetCategoryActive } from '../lib/util';

const animationName = 'animation';
const animationTime = {
  enter: 500,
  exit: 500,
};

class RegisterProductSelectorItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCategoryID: props.activeCategoryID,
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      activeCategoryID: newProps.activeCategoryID,
    });
  }

  shouldComponentUpdate(nextProps) {
    return this.state.activeCategoryID !== nextProps.activeCategoryID;
  }

  render() {
    const {
      data, categories, level, switchActiveCategoryID, selectProduct,
    } = this.props;

    const category = getItemById({
      id: data.id,
      array: categories,
      key: 'category_ID',
    });

    const isActive = isTargetCategoryActive({
      targetID: data.id,
      currentActiveID: this.props.activeCategoryID,
      categories,
    });

    let hasChildren = false;
    if (data.children && data.children.length > 0) {
      hasChildren = true;
    }
    const isProduct = !!data.product;

    const itemClassName = classnames({
    'sidebar-item': true,
      [`menu-level-${level}`]: true,
      'is-active': isActive,
    });

    // const linkClassName = classnames({
    //   [`menu-level-${level}`]: true,
    //   'is-active': isActive,
    // });

    const CSSTransitionProps = {
      timeout: animationTime,
      classNames: animationName,
    };

    const handleCategoryClick = (e) => {
      if (e.target.nodeName !== 'A') {
        switchActiveCategoryID(e.target.parentNode.id * 1);
      } else {
        switchActiveCategoryID(e.target.id * 1);
      }
    };

    const handleProductClick = () => {
      selectProduct(data.product);
      const ele = document.getElementById('register-product-select');
      if(ele){
        ele.classList.remove('text-in-red');
      }
    };

    return (
      <TransitionGroup className={itemClassName} key={data.id} component="li" appear>
        <CSSTransition {...CSSTransitionProps}>
          <a
            onClick={(e) => {
              if (isProduct) {
                handleProductClick(e);
              } else {
                handleCategoryClick(e);
              }
            }}
            id={data.id}
          >
            {hasChildren && (
              <span className="icon">
                <FontAwesomeIcon icon={hasChildren ? isActive ? faCaretSquareDown : faCaretSquareRight : faAngleRight} size="xs" />
              </span>
            )}
            <span className="text">{isProduct ? `${data.product.title} ${data.product.chinese_title}` : category.title}</span>
          </a>
        </CSSTransition>
        {isActive &&
          hasChildren && (
            <CSSTransition {...CSSTransitionProps}>
              <ul className="sub-menu-list">
                {data.children.map((child, index) => (
                  <RegisterProductSelectorItem
                    key={index}
                    data={child}
                    level={level + 1}
                    categories={categories}
                    activeCategoryID={this.props.activeCategoryID}
                    switchActiveCategoryID={switchActiveCategoryID}
                    selectProduct={selectProduct}
                  />
                ))}
              </ul>
            </CSSTransition>
          )}
      </TransitionGroup>
    );
  }
}

RegisterProductSelectorItem.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.shape({}).isRequired,
  level: PropTypes.number.isRequired,
  activeCategoryID: PropTypes.number.isRequired,
  switchActiveCategoryID: PropTypes.func.isRequired,
  selectProduct: PropTypes.func.isRequired,
};

export default RegisterProductSelectorItem;



// WEBPACK FOOTER //
// ./src/components/RegisterProductSelectorItem.js